// extracted by mini-css-extract-plugin
module.exports = {"tickerWrapper":"Ticker_tickerWrapper__YGX1Z","ticker":"Ticker_ticker__pQiq2"};